"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const fieldsReducer = require("./fields");
const fieldsModalReducer = require("./fieldsModal");
const reportFileReducer = require("./file");
const reportListReducer = require("./list");
const selectedReportReducer = require("./retrieved");
const createReportReducer = require("./create");
const exportReportReducer = require("./export");
const removedReportsReducer = require("./removed");
const updateReportReducer = require("./update");
exports.initialState = {
    fields: Object.assign({}, fieldsReducer.initialState),
    fieldsModal: fieldsModalReducer.initialState,
    reportFile: Object.assign({}, reportFileReducer.initialState),
    reportList: Object.assign({}, reportListReducer.initialState),
    selectedReport: Object.assign({}, selectedReportReducer.initialState),
    createReport: Object.assign({}, createReportReducer.initialState),
    exportReport: Object.assign({}, exportReportReducer.initialState),
    removedReports: Object.assign({}, removedReportsReducer.initialState),
    updateReport: Object.assign({}, updateReportReducer.initialState)
};
/* State lenses */
const fieldsLens = monocle.Lens.fromProp('fields');
const fieldsModalLens = monocle.Lens.fromProp('fieldsModal');
const reportFileLens = monocle.Lens.fromProp('reportFile');
const reportListLens = monocle.Lens.fromProp('reportList');
const selectedReportLens = monocle.Lens.fromProp('selectedReport');
const createReportLens = monocle.Lens.fromProp('createReport');
const exportReportLens = monocle.Lens.fromProp('exportReport');
const removedReportsLens = monocle.Lens.fromProp('removedReports');
const updateReportLens = monocle.Lens.fromProp('updateReport');
/* Handlers */
const handle = (action, reducer, lens) => (state) => {
    const fn = reducer.methods[action.type];
    return fn
        ? lens.modify((current) => fn(current, action))(state)
        : state;
};
/* Reducer */
exports.default = (state = Object.assign({}, exports.initialState), action) => {
    return fp.function.flow(handle(action, fieldsReducer, fieldsLens), handle(action, fieldsModalReducer, fieldsModalLens), handle(action, reportFileReducer, reportFileLens), handle(action, reportListReducer, reportListLens), handle(action, selectedReportReducer, selectedReportLens), handle(action, createReportReducer, createReportLens), handle(action, exportReportReducer, exportReportLens), handle(action, removedReportsReducer, removedReportsLens), handle(action, updateReportReducer, updateReportLens))(state);
};
//# sourceMappingURL=index.js.map